<div class="w-100 d-flex flex-row flex-nowrap align-items-center gap-2 mb-3 px-3 px-lg-0">
  <h4 class="text-start fw-bold header-font mb-0 d-flex flex-row align-items-center">
    <app-custom-icon
      class="color-primary me-2"
      default="bi-trophy"
      customIconKey="challenges_navigation_icon"
      altText="Challenges"
    ></app-custom-icon>
    {{ section?.section_title || 'Challenges' }}
  </h4>
  <!-- View All Button -->
  <div class="ms-auto">
    <ng-container *ngIf="isDashboard">
      <button
        class="pill-btn-default pill-btn-sm text-nowrap"
        [routerLink]="challengesRoute">
        View All Challenges
      </button>
    </ng-container>
  </div>
</div>

<div class="d-flex flex-column gap-2 px-3 px-lg-0">
  <ng-container *ngIf="!(isLoading$ | async) else challengesLoading">
    <ng-container *ngIf="combinedChallenges$ | async as challenges">
      <ng-container *ngIf="challenges.length > 0; else noChallenges">
        <div class="d-flex flex-column gap-2">
          <ng-container *ngFor="let challenge of challenges | slice:0:(isDashboard ? 3 : challenges.length)">
            <app-progress-card
              class="w-100"
              (click)="openChallengeDetailModal(challenge.details, challenge)"
              [icon]="challenge?.details?.progress[0]?.total_steps === challenge?.details?.progress[0]?.completed_steps ? challenge?.details?.icon_completed_url : challenge?.details?.icon_url"
              [name]="challenge?.details?.name || challenge.name"
              [completed_steps]="challenge?.details?.progress[0]?.completed_steps"
              [total_steps]="challenge?.details?.progress[0]?.total_steps"
              [past_completions]="challenge?.details?.past_completions || 0"
              [end_date]="challenge?.details?.end_date"
              [occurrence]="challenge?.details?.occurrence"
              [icon_color]="challenge?.details?.progress[0]?.total_steps === challenge?.details?.progress[0]?.completed_steps ? 'success' : 'primary'">
            </app-progress-card>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</div>

<!-- Loading Template -->
<ng-template #challengesLoading>
  <div class="d-flex flex-column justify-content-center gap-3 align-items-center" style="text-align: center; padding: 15vh 2vw">
    <ion-spinner name="crescent"></ion-spinner>
    Loading challenges
  </div>
</ng-template>

<!-- Mobile Loading Template -->
<ng-template #challengesLoadingMobile>
  <div class="d-flex flex-column justify-content-center gap-3 align-items-center" style="text-align: center; padding: 15vh 2vw">
    <ion-spinner name="crescent"></ion-spinner>
    Loading challenges
  </div>
</ng-template>

<!-- Empty State Template -->
<ng-template #noChallenges>
  <div class="d-flex flex-column gap-3 justify-content-center align-items-center p-3">
    <app-custom-icon
      class="color-primary display-3"
      default="bi-trophy"
      customIconKey="challenges_navigation_icon"
      altText="Challenges"
    ></app-custom-icon>
    <div class="text-center d-flex flex-column">
      <h5 class="fw-bold">No Current Challenges</h5>
      <div>Check back later for new ongoing challenges.</div>
    </div>
  </div>
</ng-template>

<!-- Mobile Empty State Template -->
<ng-template #noChallengesMobile>
  <div class="d-flex flex-column gap-3 justify-content-center align-items-center p-3">
    <app-custom-icon
      class="color-primary display-3"
      default="bi-trophy"
      customIconKey="challenges_navigation_icon"
      altText="Challenges"
    ></app-custom-icon>
    <div class="text-center d-flex flex-column">
      <h5 class="fw-bold">No Current Challenges</h5>
      <div>Check back later for new ongoing challenges.</div>
    </div>
  </div>
</ng-template>